<template>
  <div class="main_header">
    <div class="toogleTitle">
      <div @click="toggleMenu" class="toggle">
        <i class="fas fa-bars"></i>
      </div>
      <div class="titleMain">
        <h1>Relatório de Recebimento e Introdução do Molde</h1>
      </div>
    </div>
    <div class="icon-logout">
      <div class="iconLogout">
        <span>{{ Username }}</span>
        <!-- Imagem vindo do servidor tutilabs -->
        <img
          src="https://tutilabs.tk/ENGENHARIA/img/undraw_profile.svg"
          alt=""
        />
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "Main",
  data() {
    return {
      Username: undefined,
      statusNavbar : false,
    };
  },
  methods: {
    logout() {

    },
    toggleMenu() {

      let navigation = document.querySelector(".navigation");
      let main_header = document.querySelector(".main_header");
      let content = document.querySelector(".content");
      let title = document.querySelector(".title-navbar");
      
      navigation.classList.toggle("active");
      main_header.classList.toggle("active");
      content.classList.toggle("active");
      // title.classList.toggle("active");
      
      this.statusNavbar = !this.statusNavbar
      this.$store.commit("MutationSetSatatusNavBar",this.statusNavbar)
    },
  },
};
</script>

<style scoped>
.dropdown-content {
  width: 100%;
  display: flex;
  justify-content: end;
}

.dropdown-content a {
  border-radius: 10%;
  z-index: 1;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  min-width: 160px;
  background-color: #f1f1f1;
  position: absolute;

  font-weight: bold;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: none;
  cursor: pointer;
}
.dropdown-content a:hover {
  background-color: #ddd;
}

.icon-logout:hover .dropdown-content a {
  display: block;
}

.icon-logout {
  margin-left: auto;
}
.icon-logout span {
  top: -18px;
  position: relative;
  color: rgb(65, 121, 58);
  padding-right: 10px;
}
.icon-logout img {
  width: 55px;
  height: 55px;
}
/* .icon-logout label {
  margin-top: 10%;
} */
.main_header {
  /* position: relative; */
  width: calc(100% - 270px);
  height: 90px;
  margin-left: 270px;
  transition: 0.5s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: var(--white);
  box-shadow: 0 0.2rem 0.2rem rgb(156 156 156);
}

.main_header.active {
  position: relative;
  width: calc(100% - 60px);
  margin-left: 60px;
  transition: 0.5s;
}

.main_header .toogleTitle {
  display: flex;
  align-items: center;
  /* flex-wrap: wrap; */
}

.main_header .toggle .fas {
  font-size: 1.5rem;
  cursor: pointer;
}

.main_header .titleMain h1 {
  width: 100%;
  color: #029e55;
  margin-left: 1.5rem;
}

@media (max-width: 780px) {
  /* .main_header {
    height: 150px;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .main_header .toogleTitle {
    align-items: stretch; */
  /* } */

  /* .icon-logout {
    margin-left: 0;
    width: 100%;
    display: block;
  } */

  .icon-logout span {
    font-size: 1.5rem;
  }

  .main_header .titleMain h1 {
    font-size: 1.3rem;
  }

  /* .iconLogout {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  } */
}

@media (max-width: 650px) {
  .main_header {
    width: 100%;
    margin-left: 0px;
    /* height: 150px; */
    justify-content: center;
    /* flex-direction: column; */
    /* align-items: flex-start; */
    /* gap: 1rem; */
  }

  .main_header.active {
    width: 100%;
    margin-left: 0px;
    position: fixed;
  }

  .main_header .titleMain h1 {
    font-size: 1rem;
  }
}

@media (max-width: 320px) {
  .main_header .titleMain h1 {
    font-size: 1.1rem;
  }

  .icon-logout span {
    font-size: 1.3rem;
  }
}
</style>